module.exports = __webpack_public_path__ + "static/media/sun-glasses-2.f886b184.jpg";